import { get } from 'lodash';
import { getMetaSiteId } from '../base-params/base-params-selectors';
export const FETCH_EXPERIMENTS_REQUEST = 'experiments/FETCH_EXPERIMENTS_REQUEST';
export const FETCH_EXPERIMENTS_SUCCESS = 'experiments/FETCH_EXPERIMENTS_SUCCESS';
export const fetchExperimentsRequest = () => ({
    type: FETCH_EXPERIMENTS_REQUEST,
});
export const fetchExperimentsSuccess = (payload) => ({
    type: FETCH_EXPERIMENTS_SUCCESS,
    payload,
});
export function fetchExperiments({ metaSiteId } = {}) {
    return async (dispatch, getState, { httpClient, errorHandler }) => {
        const msId = metaSiteId || getMetaSiteId(getState());
        const { withErrorHandler, getResolvedError } = errorHandler;
        dispatch(fetchExperimentsRequest());
        try {
            const body = await withErrorHandler(() => httpClient.get(`/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScopes?scopes=wix-comments-web&scopes=ricos&requestContext.overrideCriteria.entityId=${msId}`), {
                errorCodesMap: {},
            });
            return dispatch(fetchExperimentsSuccess(get(body.data, 'values', {})));
        }
        catch (error) {
            getResolvedError(error);
            return dispatch(fetchExperimentsSuccess({}));
        }
    };
}
//# sourceMappingURL=experiments-actions.js.map